import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { Observable } from "rxjs";
import { ICustomerExternal } from "../../master-models/customer-external.model";

interface IResponse {
  success: boolean;
  data: ICustomerExternal[];
  message: string
}

@Injectable()
export class CustomerExternalService {
  apiEndPoint = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCustomerExternalList(): Observable<IResponse> {
    return this.http.get<IResponse>(`${this.apiEndPoint}api/customer_external`, {
      headers: this.getHeaders()
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/customer-external/customer-external.service.ts